import { AdSizes, Bidder, BidderHelper } from "@repo/lib-domain-tag";
import { deviceUtil } from "@repo/lib-common";

const DeviceTypeInfo = deviceUtil.DeviceTypeInfo;
const trPageBidderHelper = new BidderHelper();

//#region criteo
/* criteo iptal edildi
const criteo_300x250 = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 4200, zoneId: 1496268 })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(criteo_300x250);


const criteo_300x600_desktop = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 4200, zoneId: 1496271 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
trPageBidderHelper.addBidder(criteo_300x600_desktop);

const criteo_336x280_desktop = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 4200, zoneId: 1496272 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes([[336, 280]]);
trPageBidderHelper.addBidder(criteo_336x280_desktop);


const criteo_970x250_desktop = Bidder.builder("criteo")
    .setIsEnabled(true).setParams({ networkId: 4200, zoneId: 1496274 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
trPageBidderHelper.addBidder(criteo_970x250_desktop);
*/
//#endregion

//#region rtbHouse
const rtbHouse = Bidder.builder("rtbhouse")
    .setIsEnabled(true).setParams({ region: 'prebid-eu', publisherId: '32e68c03e662a554d456' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(true);
trPageBidderHelper.addBidder(rtbHouse);
//#endregion

//#region adForm
const adForm_300x250_desktop = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231067 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(adForm_300x250_desktop);

const adForm_300x600_desktop = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231068 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
trPageBidderHelper.addBidder(adForm_300x600_desktop);

const adForm_970x250_desktop = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231076 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
trPageBidderHelper.addBidder(adForm_970x250_desktop);

const adForm_300x250_mobile = Bidder.builder("adform")
    .setIsEnabled(true).setParams({ mid: 1231143 })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.mobileDevices)
    .setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(adForm_300x250_mobile);
//#endregion

//#region yandex
const yandex_300x250_mobile = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-1' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.mobileDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(yandex_300x250_mobile);

const yandex_300x250_desktop = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-1' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(yandex_300x250_desktop);

const yandex_300x600_desktop = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-2' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
trPageBidderHelper.addBidder(yandex_300x600_desktop);


const yandex_970x250_desktop = Bidder.builder("yandex").setIsEnabled(true)
    .setParams({ placementId: 'R-A-2217816-3' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
trPageBidderHelper.addBidder(yandex_970x250_desktop);


//#endregion

//#region admatic
const admatic_300x250 = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(admatic_300x250);


const admatic_300x600_desktop = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
trPageBidderHelper.addBidder(admatic_300x600_desktop);

const admatic_336x280_desktop = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes([[336, 280]]);
trPageBidderHelper.addBidder(admatic_336x280_desktop);


const admatic_970x250_desktop = Bidder.builder("admatic")
    .setIsEnabled(true).setParams({ networkId: 108266335578, host: 'gkbjdy0uaftq.rtb.admatic.com.tr' })
    .setIsAnyDeviceAllowed(false).setAllowedDevices(DeviceTypeInfo.desktopDevices)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
trPageBidderHelper.addBidder(admatic_970x250_desktop);

//#endregion

//#region taboola
const taboola_300x250 = Bidder.builder("taboola")
    .setIsEnabled(true).setParams({ publisherId: 1554971, tagId: 'sozcuPrebidData_300_250' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x250);
trPageBidderHelper.addBidder(taboola_300x250);

const taboola_300x600 = Bidder.builder("taboola")
    .setIsEnabled(true).setParams({ publisherId: 1554971, tagId: 'sozcuPrebidData_300_600' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_300x600);
trPageBidderHelper.addBidder(taboola_300x600);

const taboola_970x250 = Bidder.builder("taboola")
    .setIsEnabled(true).setParams({ publisherId: 1554971, tagId: 'sozcuPrebidData_970_250' })
    .setIsAnyDeviceAllowed(true)
    .setIsAnySizeAllowed(false).setAllowedSizes(AdSizes.prebid_970x250);
trPageBidderHelper.addBidder(taboola_970x250);

//#endregion

export { trPageBidderHelper };
